import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import useEvent from "../../hooks/useEvent";
import useIsMounted from "../../hooks/useIsMounted";

export const OverlayOpener = ({ children }) => {
  const isMounted = useIsMounted(true, 1000);
  const { Events, toggleEvent } = useEvent();
  const [searchParams] = useSearchParams();

  const taskIdParam =
    searchParams.get("open") || sessionStorage.getItem("open");

  useEffect(() => {
    if (isMounted && taskIdParam) {
      toggleEvent(Events.TaskOverlay, {
        taskId: taskIdParam,
        onOpen: () => {
          const updatedSearchParams = new URLSearchParams(searchParams);

          updatedSearchParams.delete("open");
          sessionStorage.removeItem("open");

          const newUrl = `${window.location.pathname
            }?${updatedSearchParams.toString()}`;

          window.history.replaceState(null, "", newUrl);
        },
      });
    }
  }, [isMounted, taskIdParam, searchParams]);

  return <>{children}</>;
};
